import ProfileImageGraph from './ProfileImageGraph';

export default ProfileImageGraph;
